import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { NewStyleColor } from '../../../../../utils/styles-constants';
import { hexToRgba } from '../../../../../utils/style';

const Label = styled(Translate)`
	display: block;
	margin: 15px 0;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
`;

export {
	Label,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SettingsPanel/CopyPublicationUrl/styles.ts